import React, { memo } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRight, Users, Calendar, Building2 } from 'lucide-react';
export function CustomApparelPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-416">
      <Header data-id="element-417" />

      <main className="flex-grow" data-id="element-418">
        {/* Hero */}
        <section className="bg-gradient-to-br from-purple-700 to-pink-600 text-white py-20 md:py-32" data-id="element-419">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-420">
            <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-421">
              Custom Apparel for Everyone
            </h1>
            <p className="text-xl text-purple-100 max-w-3xl mx-auto mb-10" data-id="element-422">
              Whether you need 1 shirt or 1,000, we bring your creative vision
              to life. High-quality garments, expert printing, and designs that
              turn heads.
            </p>
            <a href="/contact" className="inline-flex items-center px-8 py-4 bg-white text-purple-700 font-bold rounded-full shadow-lg hover:bg-gray-50 transition-all transform hover:-translate-y-1" data-id="element-423">
              Get a Quote
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-424" />
            </a>
          </div>
        </section>

        {/* Categories */}
        <section className="py-20" data-id="element-425">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-426">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-427">
              <div className="flex flex-col items-center text-center" data-id="element-428">
                <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mb-6" data-id="element-429">
                  <Users className="h-10 w-10 text-purple-600" data-id="element-430" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-431">
                  Teams & Schools
                </h2>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-432">
                  Unify your players and students with matching spirit wear.
                  From jerseys to warm-up gear and fan merchandise, we handle it
                  all with bulk pricing options.
                </p>
                <a href="/schools-teams" className="text-purple-600 font-bold hover:underline" data-id="element-433">
                  View Team Options &rarr;
                </a>
              </div>

              <div className="flex flex-col items-center text-center" data-id="element-434">
                <div className="w-20 h-20 bg-pink-100 rounded-full flex items-center justify-center mb-6" data-id="element-435">
                  <Calendar className="h-10 w-10 text-pink-600" data-id="element-436" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-437">
                  Events & Reunions
                </h2>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-438">
                  Make your event memorable with custom commemorative shirts.
                  Perfect for family reunions, charity runs, festivals, and
                  bachelor/bachelorette parties.
                </p>
                <a href="/contact" className="text-pink-600 font-bold hover:underline" data-id="element-439">
                  Contact Us &rarr;
                </a>
              </div>

              <div className="flex flex-col items-center text-center" data-id="element-440">
                <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mb-6" data-id="element-441">
                  <Building2 className="h-10 w-10 text-teal-600" data-id="element-442" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-443">
                  Business Branding
                </h2>
                <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-444">
                  Turn your employees into brand ambassadors. Professional
                  uniforms, promotional giveaways, and merchandise that puts
                  your logo front and center.
                </p>
                <a href="/contact" className="text-teal-600 font-bold hover:underline" data-id="element-445">
                  Contact Us &rarr;
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Catalog Preview */}
        <section className="bg-gray-900 text-white py-20" data-id="element-446">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-12" data-id="element-447">
            <div className="md:w-1/2" data-id="element-448">
              <h2 className="text-3xl font-bold mb-6" data-id="element-449">
                Thousands of Products Available
              </h2>
              <p className="text-gray-400 text-lg mb-8" data-id="element-450">
                We source from top brands like Nike, Gildan, Bella+Canvas, and
                more. T-shirts, hoodies, polos, hats, bags - if you can wear it,
                we can print on it.
              </p>
              <ul className="space-y-3 mb-8" data-id="element-451">
                <li className="flex items-center text-gray-300" data-id="element-452">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3" data-id="element-453"></span>
                  Premium soft-style blends
                </li>
                <li className="flex items-center text-gray-300" data-id="element-454">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3" data-id="element-455"></span>
                  Performance moisture-wicking fabrics
                </li>
                <li className="flex items-center text-gray-300" data-id="element-456">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-3" data-id="element-457"></span>
                  Eco-friendly and sustainable options
                </li>
              </ul>
            </div>
            <div className="md:w-1/2 bg-gray-800 rounded-2xl p-8 text-center border border-gray-700" data-id="element-458">
              <h3 className="text-xl font-bold mb-4" data-id="element-459">Need help choosing?</h3>
              <p className="text-gray-400 mb-6" data-id="element-460">
                Our experts can recommend the perfect garment for your specific
                needs and budget.
              </p>
              <a href="/contact" className="inline-block px-8 py-3 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-full transition-all" data-id="element-461">
                Contact Us
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-462" />
    </div>;
}